// This file is AUTOGENERATED, do not edit it manually!!!

export const projectFinancials = {
    actual_billing: 'Фактическая выручка',
    actual_cost: 'Фактическая стоимость',
    ActualBillableExpenses: 'Фактические оплачиваемые расходы',
    ActualBillableExpensesShort: 'Факт. опл. расходы',
    ActualBilledShort: 'Факт. выст. счет',
    ActualBillingShort: 'Факт. выручка',
    ActualBudgetProfitability: 'Фактическая рентабельность бюджета',
    ActualCost: 'Факт. стоимость',
    ActualCostQtip: 'Факт. стоимость = Трудозатраты + Затраты',
    ActualExpenses: 'Фактические расходы',
    ActualExpensesListTitle: 'Фактические',
    ActualExpensesShort: 'Факт. расходы',
    ActualHours: 'Факт. часы',
    ActualLaborBilling: 'Фактические оплачиваемые трудозатраты',
    ActualLaborBillingShort: 'Факт. опл. трудозатр.',
    ActualLaborCost: 'Фактические трудозатраты',
    ActualLaborCostShort: 'Факт. трудозатр.',
    add_activities_flat_fees: 'добавить фикс. ставки активностей',
    add_as_actual_expense: 'Добавить как фактический расход',
    add_planned_billable_expenses: 'добавить заплан. оплачиваемые расходы',
    add_received_payment: 'Внести полученный платеж',
    add_scheduled_payment: 'Внести запланированный платеж',
    AddActivitiesBudgets: 'добавить бюджеты активностей',
    AddBudgetLabel: 'Добавить бюджет для проекта',
    AddPlannedExpenses: 'добавить запланированные расходы',
    Amount: 'Сумма',
    approver_label: 'Утверждающий',
    approvers_problem_warning: 'Один из утверждающих больше не может утверждать расходы. Обновите список утверждающих.',
    ApproveTooltip: 'Переносит затраты из запланированных в фактические',
    back_to_metrics: 'Назад к метрикам',
    batch_actual_text: 'Добавить как фактические',
    batch_approval_text: 'Утвердить расходы',
    batch_billed_text: 'Пометить как выставленные',
    batch_operation_failed_description: 'Для данной записи операцию выполнить не удалось. Причиной могло являться удаление записи к моменту операции или отсутствие прав на выполнение операций с ней. Свяжитесь с администратором {brandName} на предмет возможных причин.',
    batch_operations_failed_description: 'Для {0} из {1} записей операцию выполнить не удалось. Причиной могло являться удаление записей к моменту операции или отсутствие прав на выполнение операций с ними. Свяжитесь с администратором {brandName} на предмет возможных причин.',
    batch_reject_text: 'Отклонить расходы',
    Billable: 'Оплачив.',
    Billed: 'Оплачено',
    BilledPercentQtip: 'Оплачено = (Оплаченные трудозатраты + Оплаченые фактические затраты) / Прогнозную сумму к оплате * 100%',
    BilledVsActualCost: 'Оплаченное к общим издержкам',
    Billing: 'Выручка',
    Billing_Info_Title: 'Биллинг',
    billing_type_item_readonly: 'Редактирование недоступно в таблице, когда тип тарификации - Карта ставок. Вы можете отредактировать это в разделе Финансы',
    BillingHelp: 'В разделе Тарификация вы можете выбрать нужный тип тарификации для ​​проекта и устанавить ставки, такие как почасовую или фиксированную сумму для проекта.',
    BillingSettings: 'Настройки биллинга',
    BillingSettingsTitle: 'Биллинг',
    BillingType: 'Тип биллинга',
    BillingTypeLabel: 'Расчет по ',
    BillingUtilization: 'Доля оплаченных неиспользованных трудозатрат',
    BudgetedCost: 'Общий бюджет',
    BudgetHelp: 'В этом разделе вы можете просмотреть общий бюджет проекта включая все активности, и установить бюджет для самого проекта.',
    CancelTooltip: 'Отмена',
    chart_actual_billing: 'Выставлено к оплате',
    chart_actual_cost: 'Общие издержки',
    chart_billable_expenses: 'Оплачиваемые расходы',
    chart_billed: 'Оплачено',
    chart_billed_expenses: 'Оплачено',
    chart_eac_billing: 'Итоговая сумма к оплате',
    chart_expenses: 'Расходы',
    chart_non_billable_expenses: 'Неоплачиваемые расходы',
    chart_payments: 'Полученные платежи',
    chart_scheduled_payments: 'Запланированные платежи',
    ContingencyPadding: 'Запас бюджета',
    Cost: 'Общая стоимость',
    CurrencyLabel: 'Валюта',
    CustomerHourlyRateLabel: 'Часовая ставка заказчика',
    Date: 'Дата',
    delete_the_expense_title: 'Удалить расход',
    delete_the_payment_title: 'Удалить платеж',
    DeletePaymentConfirmation: 'ВЫ действительно хотите удалить запись?',
    DeleteTooltip: 'Удалить',
    Description: 'Описание',
    DetailedReportTitleTemplate: 'Детальный отчет для {0}',
    EAC: 'ПОПЗ',
    eac_billing: 'Предварительная оценка выручки по завершению (ПОПЗ)',
    eac_cost: 'Предварительная оценка стоимости по завершению (ПОПЗ)',
    EACBilling: 'ПОПЗ выручка',
    EACBillingLong: 'Ожидаемая итоговая выручка',
    EACBillingQtip: 'ПОПЗ выручка = Фактическая выручка + Ожидаемая выручка завершения',
    EACBillingQtipInfo: 'Ожидаемая сумма к оплате, включающая трудозатраты и затраты (Фактические + Ожидаемые до завершения)',
    EACCost: 'Ожидаемая итоговая стоимость',
    EACCost_short: 'ПОПЗ стоимость',
    EACCostQtip: 'Ожидаемая итоговая стоимость = Общие издержки + Ожидаемая стоимость завершения',
    EnteredBy: 'Внесено',
    EstimatedBudgetProfitability: 'Ожидаемая рентабельность бюджета',
    EstimatedCostVariance: 'Ожидаемое отклонение бюджета',
    EstimatedExpenses: 'Ожидаемые расходы',
    EstimatedHours: 'Примерн. часы',
    EstimatedProfit: 'Ожидаемая прибыль',
    EstimatedProfitPercentQtip: 'Ожидаемая прибыль (%) = (Прогнозная сумма к оплате - Ожидаемая итоговая стоимость) / Прогнозная сумма к оплате * 100%',
    EstimatedProfitQtip: 'Ожидаемая прибыль = Прогнозная сумма к оплате - Ожидаемая итоговая стоимость',
    etc_billing: 'Ожидаемая выручка завершения',
    etc_cost: 'Ожидаемая стоимость завершения',
    ETCBillableExpenses: 'Ожидаемые оплачиваемые расходы',
    ETCBillableExpensesShort: 'Ожид. опл. расх.',
    ETCBilling: 'Ожидаемая выручка завершения',
    ETCBillingShort: 'Ожид. выручка зав.',
    ETCCost: 'Ожидаемая стоимость завершения',
    ETCCostShort: 'Ожид. стоим. зав.',
    ETCCosttQtip: 'Ожидаемая стоимость завершения = Прогнозные трудозатраты + Прогнозные затраты',
    ETCExpenses: 'Ожидаемые расходы',
    ETCExpensesShort: 'Ожид. расх.',
    ETCLaborBilling: 'Ожидаемые оплачиваемые трудозатраты',
    ETCLaborBillingShort: 'Ожид. опл. трудозатр.',
    ETCLaborCost: 'Ожидаемые трудозатраты',
    ETCLaborCostShort: 'Ожид. трудозатр.',
    ExpectedRevenue: 'Ожидаемый доход',
    expenses: '7#{0} расход#{0} расхода#{0} расходов',
    expenses_approval_info: 'Включает утверждение расходов для всего проекта и всех его мероприятий.',
    expenses_approval_label: 'Утверждение расходов',
    expenses_approval_remove_all_approvers_title: 'Удаляет всех утверждающих, что отключает процесс утверждения расходов после сохранения.',
    expenses_approval_status_approved: 'Одобрено',
    expenses_approval_status_none: 'Ожидает согласования',
    expenses_approval_status_rejected: 'Отклонено',
    expenses_approved_successfully_plural: '7#Расход согласован#{0} расхода согласовано#{0} расходов согласовано',
    expenses_rejected_successfully_plural: '7#Расход отменен#{0} расхода отменены#{0} расходов отменены',
    expenses_updated_successfully_plural: '7#Запись была успешно обновлена.#{0} записи были обновлены.#{0} записей были обновлены.',
    FeeAmount: 'Величина платежа',
    FlatFee: 'Фиксированная стоимость',
    GeneralInfo: 'Общая информация',
    HourlyRate: 'Часовая ставка',
    InternalBudget: 'Бюджет',
    InternalEstimatedCost: 'Ожидаемая стоимость',
    LaborBilling: 'Выставлено к оплате по трудозатратам',
    LaborCost: 'Трудозатраты',
    legend_actual: 'Факт',
    legend_estimated_at_completion: 'Прогноз',
    log_actual_expense: 'Внести фактический расход',
    log_expenses: 'Внести расходы',
    log_payments: 'Внести платежи',
    log_planned_expense: 'Внести плановый расход',
    money_for_date_label: '{0} для {1}?',
    no_targets: 'Нет целей для показа',
    NoActualExpenses: 'Нет затрат.',
    None: 'Нет',
    NoneCurrency: 'Выбрать валюту',
    NoPayments: 'Нет платежей.',
    NoPlannedExpenses: 'Нет плановых затрат.',
    NotBillable: 'Не выставлен к оплате',
    NotBillableLabel: 'Неоплачиваемый',
    NotBilled: 'Не оплачено',
    OpenRateCard: 'Открыть карту ставок',
    OutstandingPaymentBalance: 'Непогашенный платежный баланс',
    PaymentDescriptionWatermark: 'Описание...',
    PaymentReceived: 'Платеж получен',
    payments_total: '7#{0} платеж#{0} платежа#{0} платежей',
    PaymentsOfSchedPayments: 'Получено из запланир. платежей',
    PercentageBilled: 'Процент выставленной работы',
    PercentageProjectBilled: 'Процент выставленной работы',
    Percentages: 'Проценты',
    PlannedExpenses: 'План. расходы',
    PlannedExpensesListTitle: 'Плановые',
    ppFormat: '{0}пп',
    Profit: 'Прибыль',
    ProfitQtip: 'Прибыль = Выставлено к оплате - Общие издержки',
    Project_no_rateCard_for_rateCard_billingType: 'Необходимо указать карту ставок, если оплата расчитывается на основе карты ставок.',
    ProjectActivityName: 'Имя Проекта / Задачи',
    ProjectBilling: 'Выставлено к оплате',
    ProjectBillingIsBasedOn: 'Выставление счетов на основе',
    ProjectBillingUtilization: 'Утилизация биллинга',
    ProjectBudget: 'Бюджет труда',
    ProjectCost: 'Внутренняя стоимость проекта',
    ProjectCostVariance: 'Отклонение от бюджета',
    ProjectEarnedValue: 'Стоимость, заработанная проектом',
    ProjectEarnedValueInfo: 'Отражает здоровье проекта',
    ProjectExpectedRevenue: 'Расчетная выручка проекта',
    ProjectFixedCostLabel: 'Фиксированная ставка для проекта',
    ProjectHourlyRateLabel: 'Часовая ставка проекта',
    ProjectPayments: 'Платежи по проекту',
    ProjectPlannedExpenses: ' Плановые расходы проекта',
    ProjectPlannedExpensesInfo: 'Расходы, запланированные на определенный проект и запланированные расходы, суммированные по его активностям  ',
    ProjectProfit: 'Прибыль по проекту',
    ProjectProfitability: 'Рентабельность проекта',
    ProjectProfitabilityInfo: 'Отражает процент стоимости, созданной каждым проектом',
    ProjectTimeUsage: ' Времязатратность проекта',
    ProjectTimeUsageInfo: 'Показывает, сколько времени, предусмотренном в бюджете, вы использовали, фактическое как процент от оценочного ',
    ProjectWorkInProgress: 'Доля текущих трудозатрат',
    PymentsVsActualCost: 'Платежи к общим издержкам',
    RateCardLabel: 'Карта ставок',
    Receipt: 'Чеки',
    Received: 'Получено',
    ReceivedPaymentsListTitle: 'Полученные',
    RemainingInternalBudget: 'Оставшийся бюджет',
    RemainingInternalBudgetQtip: 'Оставшийся бюджет = Бюджет - Общие издержки',
    RemainingInternalBudgetQtipForProject: 'Оставшийся бюджет = Общий бюджет - Общие издержки',
    ResourceHourlyRateLabel: 'Часовая ставка исполнителя',
    Revenue: 'Целевая выручка',
    revert_approval_text: 'Редактирование этого расхода сбросит его статус на «Ожидает утверждения» и перезапустит процесс согласования с самого начала. Все предыдущие одобрения или отклонения будут утрачены. Вы хотите продолжить?',
    revert_approval_title: 'Отменить расход для повторного утверждения?',
    Scheduled: 'Запланировано',
    ScheduledPaymentsListTitle: 'Запланированные',
    set_targets: 'Настройте цели, используя',
    Settings: 'Настройки',
    ShowAll: 'ПОКАЗАТЬ ВСЁ',
    ShowBreakdown: 'Показать разбивку',
    status_label: 'Статус',
    tab_Actual: 'Фактические расходы',
    tab_expenses: 'Расходы',
    tab_overview: 'Обзор',
    tab_payments: 'Платежи',
    tab_Planned: 'Плановые расходы',
    tab_Received: 'Полученные платежи',
    tab_Scheduled: 'Запланированные платежи',
    tab_targets: 'Цели',
    TargetBudget: 'Общий бюджет',
    TargetLaborRevenue: 'Целевая выручка от труда',
    TargetProfit: 'Целевая прибыль',
    TargetRevenue: 'Целевая выручка',
    Targets: 'Цели',
    targets_tab: 'вкладку Цели',
    TargetsEACBilling: 'ПОПЗ выручка',
    TaskRateLabel: 'Часовая ставка активности',
    TimeAndMaterial: 'Время и материалы',
    TimeUsage: 'Утилизация времени',
    TitleText: 'Финансы',
    total_billable: 'Общая выручка',
    TotalBilled: 'Всего оплачено',
    TotalProjectBudget: 'Общий бюджет проекта',
    TotalProjectPayments: 'Суммарные платежи по проекту',
    TotalProjectPaymentsInfo: 'Сумма платежей от всех заказчиков',
    TotalTargetRevenue: 'Общая выручка проекта',
    TrackProfitAs: 'Отслеживать прибыль как',
    Validation_DateMandatory: 'Дата обязательна для заполнения.',
    Validation_InvalidAmount: 'Должно быть положительным числом.',
    Validation_InvalidDate: 'Введите дату в формате \'{0}\'.',
    Validation_Range: 'Значение попало в недопустимы диапазон.',
    Variance: 'Oтклонение',
    warning_currency: 'Валюта задана в выбранной карте ставок',
    WorkInProgress: 'Работа в процессе',
};
